module.exports = __webpack_public_path__ + "img/subline2_rus.91faa971.png";